import { Select } from 'antd';
import { Field, useFormikContext } from 'formik';
import { Text } from '.';
import { classNames } from 'src/utilities';

export const SingleSelect = ({
  name,
  label,
  disabled,
  placeholder,
  value,
  options,
  onChange,
  className,
  popupClassName,
  dropdownArrow,
  extraIcon,
  onSearch,
  loading,
  notFoundContent,
  getPopupContainer,
}) => {
  const formik = useFormikContext();
  return (
    <Field name={name}>
      {({ form: { setFieldValue, setFieldTouched } }) => {
        return (
          <div className="w-full custom-select-component">
            {label ? (
              <Text type={'label'} htmlFor={name}>
                {label}
              </Text>
            ) : null}
            <Select
              bordered={false}
              id={name}
              showSearch={true}
              optionFilterProp="label"
              disabled={disabled}
              placeholder={placeholder}
              className={classNames(
                'font-sans w-full',
                className ? className : 'single-select'
              )}
              showArrow={dropdownArrow}
              suffixIcon={extraIcon}
              popupClassName={classNames(
                'single-select__dropdown',
                popupClassName ? popupClassName : ''
              )}
              options={options}
              onSearch={onSearch}
              loading={loading}
              notFoundContent={notFoundContent}
              getPopupContainer={getPopupContainer}
              dropdownStyle={{
                zIndex: 999999999,
              }}
              value={value || formik?.values?.name?.fieldIndex?.Duration}
              onChange={(value, option) => {
                setFieldValue(name, value);
                if (onChange) {
                  onChange(value, option);
                  name === 'practitioner_id' &&
                    setFieldValue('condition_id', '');
                }
              }}
              onBlur={() => {
                setFieldTouched(name, true);
              }}
            />
            {/* {meta?.touched && meta?.error ? (
                            <Text type={"error"} className={"error mt-2"}>
                                {meta?.error}
                            </Text>
                        ) : null} */}
          </div>
        );
      }}
    </Field>
  );
};
